// @react/hooks/useApikeyApiKeyPolicy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { apikeyApiKeyPolicyStore } from '@core/stores';

/**
 * React hook for APIKeyPolicy operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useApikeyApiKeyPolicy } from '@react/hooks';
 *
 * const APIKeyPolicyList = observer(() => {
 *   const store = useApikeyApiKeyPolicy();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useApikeyApiKeyPolicy() {
  return apikeyApiKeyPolicyStore;
}
